import { AxiosError } from 'axios';
import type { RequestResult } from '../types/empathy-requests';
import type { RingAcceptResult } from '../types/ring';
import api from './api';
import { globallyHandledRefusal } from './empathy-requests.service';

/**
 * The in-app ring's two answers (P7d). Each RETURNS the server's refusal
 * (class B): `taken` ("Someone else took this call."), `no_longer_needed`,
 * and the claim's own codes, with the server's sentence shown as is.
 */

const FALLBACK = "Couldn't reach the server. Check your connection and try again.";

function refusal<T>(error: unknown): RequestResult<T> {
  const handled = globallyHandledRefusal<T>(error);
  if (handled) return handled;
  if (error instanceof AxiosError && error.response?.data) {
    const data = error.response.data as { error?: unknown; message?: unknown };
    if (typeof data.error === 'string') {
      return {
        success: false,
        error: data.error,
        message: typeof data.message === 'string' && data.message ? data.message : FALLBACK,
      };
    }
  }
  return { success: false, error: 'network', message: FALLBACK };
}

/** Accept: the same claim / match path the push tap leads to. */
export async function acceptRing(id: number): Promise<RequestResult<RingAcceptResult>> {
  try {
    const response = await api.post<{ data: RingAcceptResult }>(`/empathy/rings/${id}/accept`);
    return { success: true, data: response.data.data };
  } catch (error) {
    return refusal(error);
  }
}

/** Not now: this ring only (no pause). */
export async function declineRing(id: number): Promise<RequestResult<{ ring_id: number }>> {
  try {
    const response = await api.post<{ data: { ring_id: number } }>(`/empathy/rings/${id}/decline`);
    return { success: true, data: response.data.data };
  } catch (error) {
    return refusal(error);
  }
}
